import type { ComponentChildren } from "preact";

type SectionProps = { children: ComponentChildren; class?: string; id?: string };

export const Section = ({ children, class: className = "", id }: SectionProps) => (
  <section id={id} class={`px-4 py-14 md:py-20 ${className}`}>
    <div class="max-w-5xl mx-auto">{children}</div>
  </section>
);

type HeadingProps = { title: string; intro?: string; align?: "left" | "center" };

export const SectionHeading = ({ title, intro, align = "center" }: HeadingProps) => (
  <div class={`max-w-2xl mb-10 ${align === "center" ? "mx-auto text-center" : ""}`}>
    <h2 class="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-50">{title}</h2>
    {intro && <p class="mt-3 text-lg text-gray-600 dark:text-gray-300">{intro}</p>}
  </div>
);
